export const ADDFLIGHT = "flight/add";
export const REMOVEFLIGHT = "flight/remove";